import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Camera, ArrowRight } from "lucide-react";

// The signature MOIRÉ action. Premium, tactile, restrained gold response.
export default function SnapButton({ variant = "solid", label = "Snap Your Item", to = "/match", size = "lg", testid = "snap-button", icon = true }) {
  const navigate = useNavigate();
  const pad = size === "lg" ? "px-9 py-4 md:py-5 text-sm" : "px-6 py-3 text-xs";

  if (variant === "outline") {
    return (
      <motion.button
        onClick={() => navigate(to)} data-testid={testid}
        whileHover={{ y: -2 }} whileTap={{ scale: 0.97 }}
        transition={{ type: "spring", stiffness: 400, damping: 22 }}
        className={`group relative inline-flex items-center gap-3 border border-[#C8A97E] text-[#C8A97E] ${pad} font-sans tracking-luxe uppercase overflow-hidden hover:text-[#0D0D0D] transition-colors duration-300`}
      >
        <span className="absolute inset-0 bg-[#C8A97E] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out" />
        {icon && <Camera size={16} strokeWidth={1.75} className="relative z-10" />}
        <span className="relative z-10">{label}</span>
      </motion.button>
    );
  }

  return (
    <motion.button
      onClick={() => navigate(to)} data-testid={testid}
      whileHover={{ y: -2 }} whileTap={{ scale: 0.97 }}
      transition={{ type: "spring", stiffness: 400, damping: 22 }}
      className={`group relative inline-flex items-center gap-3 bg-[#C8A97E] text-[#0D0D0D] ${pad} font-sans tracking-luxe uppercase overflow-hidden hover:bg-[#E5C293] transition-colors duration-300 shadow-[0_10px_40px_-12px_rgba(200,169,126,0.55)]`}
    >
      {/* subtle shimmer sweep on hover */}
      <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out"
        style={{ background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.35), transparent)" }} />
      {icon && <Camera size={17} strokeWidth={2} className="relative z-10" />}
      <span className="relative z-10">{label}</span>
      <ArrowRight size={16} strokeWidth={2} className="relative z-10 group-hover:translate-x-1 transition-transform duration-300" />
    </motion.button>
  );
}
